import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FilledInput from '@material-ui/core/FilledInput';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { NavLink, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faExclamationCircle, faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import Header from '../Headers/Header';
import ErrorMessage from '../AppLayouts/ErrorMessage';
import Cookies from 'js-cookie';
import API_PATH from "../../constants/config.json";
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

//Start ResetPassword component code ....
export default function ResetPasswordV2() {
    const [spacing, setSpacing] = React.useState(2);
    const [passwordValues, setPasswordValues] = React.useState({
        pwd: "",
        cnfNewPwd: "",
        confirmationcode: ""
    });
    const [errPopUp, setErrPopUp] = React.useState(false);
    const [errMsg, setErrMsg] = React.useState(null);
    const [errMsgType, setErrMsgType] = React.useState('error');
    const [errPassword, setErrNewPassword] = React.useState(null);
    const [errCnfPassword, setErrCnfPassword] = React.useState(null);
    const [errCode, setErrCode] = React.useState(null);

    const [validCode, setValidCode] = useState(false);
    const [validPwd, setValidPwd] = useState(false);
    const [validLen, setValidLen] = useState(false);
    const [validNum, setValidNum] = useState(false);
    const [validUpper, setValidUpper] = useState(false);
    const [validLower, setValidLower] = useState(false);
    const [validSpecialCh, setValidSpecialCh] = useState(false);
    const [activeWatch, setActiveWatch] = useState(true);

    const [timerInterval, setTimerInterval] = useState(null);

    let timeInterval;
    // let timerInterval;
    let history = useHistory();
    React.useEffect(() => {
        setErrMsg('An email has been sent to the email you provided');
        setErrMsgType('success');
        setErrPopUp(true);
        watcher();
    }, []);
    let min = 4, sec = 60

    const watcher = () => {
        let tmint = setInterval(function () {
            startTime();
            let showTime = document.getElementById("timeDiv");
            if (showTime) {
                showTime.innerHTML = sec < 10 ? "0" + min + ":0" + sec : "0" + min + ":" + sec;
            }
        }, 1000);
        setTimerInterval(tmint);
    }

    const startTime = () => {
        let showTime = document.getElementById("timeDiv");
        sec--;
        if (sec === 0) {
            sec = 59;
            min--;
            if (min < 0) {
                showTime.style.display = "none";
                clearInterval(timerInterval);
                setActiveWatch(false);
            }
        }
    }


    const handleChange = (event) => {
        setSpacing(Number(event.target.value));
    };
    const ShowErrPopUP = () => {
        setErrPopUp(false);
    };

    const passwordHandleChange = name => event => {
        setErrNewPassword(false);
        setErrCnfPassword(false);
        setErrCode(false);
        setPasswordValues({ ...passwordValues, [name]: event.target.value });

        let passwordCheck = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^\$\*\.\[\]\{\}\(\)\?\"\!\@\#\%\&\/\\,\>\<\'\:\;\|\_\~\`])[A-Za-z\d\^\$\*\.\[\]\{\}\(\)\?\"\!\@\#\%\&\/\\,\>\<\'\:\;\|\_\~\`]{8,}$/
        let val = event.target.value;
        if (name == 'confirmationcode') {
            let vCode= val !== "" ? true : false;
            setValidCode(vCode);
        } else if (name == 'pwd') {
            let tmp = val.length >= 8 ? true : false;
            setValidLen(tmp);
            setValidNum((/\d/).test(val));
            setValidUpper((/[A-Z]/).test(val));
            setValidLower((/[a-z]/).test(val));
            setValidSpecialCh((/[\^\$\*\.\[\]\{\}\(\)\?\"\!\@\#\%\&\/\\,\>\<\'\:\;\|\_\~\`]/).test(val));
    
            let vPwd = passwordCheck.test(val);
            setValidPwd(vPwd);
        } 
    }


    //This code is use for API call to request verification code to recover password .... start
    const recoverPassword = () => { 
        clearInterval(timerInterval);
        setErrMsg(null);
        try {
            axios({
                method: 'post',
                data: { ...passwordValues, ...{ 'email': Cookies.get('email') } },
                url: API_URL + API_PATH.confirmForgotPasswordAPI,
            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        let showTime = document.getElementById("timeDiv");   
                        showTime.style.display = "none";
                        clearInterval(timerInterval);
                        setActiveWatch(false);              
                        history.push('./password_updated');
                        Cookies.remove('email');       
                    } else {
                        setErrMsgType('error');
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true);
                    }
                })
                .catch(function (error) {
                    if (error.response) {
                        setErrMsgType('error');
                        setErrMsg(error.response.data.message.message);
                        setErrPopUp(true);
                    } else {
                        setErrMsgType('error');
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true);
                    }
                    let showTime = document.getElementById("timeDiv");
                    showTime.style.display = "none";
                    clearInterval(timerInterval);
                    setActiveWatch(false);
                })
        } catch (error) {
            console.error(error);
            setErrMsgType('error');
            setErrMsg(error.response.data.message.message);
            setErrPopUp(true);
        }
    }
    //This code is use for API call to request verification code to recover password .... end

    
    
    //This code is use API call to request verification code to recover password ... start
    const resendCode = () => {
        let showTime = document.getElementById("timeDiv");
        clearInterval(timerInterval);
        min = 4;
        sec = 60;
        showTime.innerHTML = "05:00";
        showTime.style.display = "block";
        watcher();
        setActiveWatch(true);
        setErrMsg(null);
        try {
            axios({
                method: 'post',
                data: { 'email': Cookies.get('email') },
                url: API_URL + API_PATH.forgotPasswordAPI,
            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        setErrMsgType('success')
                        setErrMsg('An email has been sent to the email you provided.');
                        setErrPopUp(true)
                    } else {
                        setErrMsgType('error')
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true)
                    }
                })
                .catch(function (error) {
                    if (error.response) {
                        setErrMsgType('error');
                        setErrMsg(error.response.data.message.message);
                        setErrPopUp(true);
                    } else {
                        setErrMsgType('error');
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true);
                    }
                })
        } catch (error) {
            console.error(error);
        }
    }
    //This code is use API call to request verification code to recover password ... end

    const handleClose = () => {
        clearInterval(timerInterval);
        history.push('/');
    }

    return (
        <React.Fragment>
            {/* <Header /> */}
            <CssBaseline />
            <div className="signin-main">
                <Container maxWidth="sm" className="user-form-container">
                    <Typography component="div">
                        <div className="form-logo">
                            <NavLink to="/" title='Close'><img className="close-icon" src={require('../../assets/icons/close.svg')} onClick={handleClose} /></NavLink>
                            <img src={require('../../assets/images/dataPointLogo.svg')} className="form-icon"></img>
                        </div>
                        <form className="root-form" noValidate autoComplete="off">
                            <h3 className="h3-title">Update password</h3>
                            <Grid container className="root-box">
                                <Grid item xs={12}>
                                    {errMsg ? <ErrorMessage message={errMsg} visible={ShowErrPopUP} show={errPopUp} msgType={errMsgType} /> : null}
                                    <Grid container justify="center" spacing={spacing}>
                                        <Grid xs={12} item>
                                            <Paper className="paper" >
                                                <p className="text-input-label">Verification code</p>
                                                <FilledInput 
                                                    id="verification_code" 
                                                    placeholder="" 
                                                    className={errCode ? "form-text-input-error" : "form-text-input"} 
                                                    type="tel" variant="outlined" required 
                                                    onChange={passwordHandleChange('confirmationcode')} 
                                                    data-testid='verification_code' 
                                                    endAdornment={ errCode && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> }
                                                />
                                                {errCode ? <p className="form-error-label">{errMsg}</p> : null}
                                            </Paper>
                                        </Grid>
                                        <Grid xs={12} item>
                                            <Paper className="paper" >
                                                <p className="text-input-label">New password</p>
                                                <FilledInput 
                                                    id="new_password" 
                                                    placeholder="" 
                                                    className={errPassword ? "form-text-input-error" : "form-text-input"} 
                                                    type="password" variant="outlined" required 
                                                    onChange={passwordHandleChange('pwd')} 
                                                    data-testid='new_password' 
                                                    endAdornment={ errPassword && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> }
                                                />
                                            </Paper>
                                        </Grid>
                                        <Grid xs={12} item>
                                            <Paper className="paper" >
                                                <label className="gray-light-label">Password must contain the following:</label>
                                                <ul className="signup-list">
                                                <li className="gray-light-label"><FontAwesomeIcon icon={validLen ? faCheckCircle : faTimesCircle} className={validLen ? "successful-icon" : "error-icon"} /> At least 8 characters</li>
                                                <li className="gray-light-label"><FontAwesomeIcon icon={validNum ? faCheckCircle : faTimesCircle} className={validNum ? "successful-icon" : "error-icon"} /> Include a number</li>
                                                <li className="gray-light-label"><FontAwesomeIcon icon={validUpper ? faCheckCircle : faTimesCircle} className={validUpper ? "successful-icon" : "error-icon"} /> Include an upper case character</li>
                                                <li className="gray-light-label"><FontAwesomeIcon icon={validLower ? faCheckCircle : faTimesCircle} className={validLower ? "successful-icon" : "error-icon"} /> Include a lower case character</li>
                                                <li className="gray-light-label"><FontAwesomeIcon icon={validSpecialCh ? faCheckCircle : faTimesCircle} className={validSpecialCh ? "successful-icon" : "error-icon"} /> Include a special character</li>
                                                </ul>
                                            </Paper>
                                        </Grid>
                                        <Grid xs={12} item>
                                            <div id="timeDiv" className="time-text-context">05:00</div>
                                            <Paper className="paper" style={{ textAlign: 'center', display: 'block' }} >
                                                {
                                                    !activeWatch ?
                                                        <Button type="button" variant="outlined" id="resend_code" data-testid="update_pw_btn" 
                                                        className="blue-btn" value="Resend Code" onClick={resendCode}
                                                        >
                                                        Resend Code</Button>
                                                    :
                                                    <Button type="button" variant="outlined" id="update_My_btn" data-testid="update_pw_btn" 
                                                    className="blue-btn" value="Update password" 
                                                    disabled={validCode && validPwd ? false : true } onClick={recoverPassword}>
                                                        Update password</Button>
                                                }
                                            </Paper>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                    </Typography>
                </Container>
            </div>
        </React.Fragment>
    );
}
//End ResetPassword component code ....